import { render, staticRenderFns } from "./areaTranscriber.vue?vue&type=template&id=4fa471e6&scoped=true"
import script from "./areaTranscriber.vue?vue&type=script&lang=js"
export * from "./areaTranscriber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa471e6",
  null
  
)

export default component.exports